import { render } from "./PopularPosts.vue?vue&type=template&id=7450959c"
import script from "./PopularPosts.vue?vue&type=script&lang=js"
export * from "./PopularPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__